webpackJsonp([168648818355148],{

/***/ 1578:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/ddbd/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-ddbd-9231f79e3249c0439827.js